import { useState } from 'react';

import { VoidFunctionNoArgs } from 'types';

type returnFunctionType = {
  isOpen: boolean;
  toggle: VoidFunctionNoArgs;
  open: VoidFunctionNoArgs;
  close: VoidFunctionNoArgs;
};
function useModal(): returnFunctionType {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggle = (): void => {
    setIsOpen(current => !current);
  };

  return {
    isOpen,
    toggle,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };
}
export { useModal };
